import ModusServiceModel from "../ModusServiceModel";
import ResultEventModel from "./ResultEventModel";
import ResultEventSampleModel from "./ResultEventSampleModel";
import ResultRecommendationModel from "./ResultRecommendationModel";
import ResultNutrientRecommendationElementCollection
  from "@/collections/modus/ResultNutrientRecommendationElementCollection";

export default class ResultNutrientRecommendationModel extends ModusServiceModel {
  modelName() {
    return 'result-nutrient-recommendations';
  }
  icon() {
    return 'poll';
  }
  defaults() {
    return {
      id: null,
      result_event_id: null,
      result_event: null,
      result_event_sample_id: null,
      result_event_sample: null,
      result_recommendation_id: null,
      result_recommendation: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      result_nutrient_recommendation_elements: {}
    }
  }
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      result_event_id: (val) => (this.nullStringMutator(val)),
      result_event_sample_id: (val) => (this.nullStringMutator(val)),
      result_recommendation_id: (val) => (this.nullStringMutator(val)),
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val))
    }
  }
  validation() {
    return {}
  }
  getResultEvent() {
    return this.getRelatedModel(ResultEventModel, 'result_event');
  }
  getResultEventSample() {
    return this.getRelatedModel(ResultEventSampleModel, 'result_event_sample');
  }
  getResultRecommendation() {
    return this.getRelatedModel(ResultRecommendationModel, 'result_recommendation');
  }
  getResultNutrientRecommendationElements() {
    return this.getRelatedCollection(
      new ResultNutrientRecommendationElementCollection(),
      'result_nutrient_recommendation_elements'
    );
  }
}
